module.exports = __webpack_public_path__ + "static/media/es.8c679821.jpg";